import { render } from "./OfferInfo.vue?vue&type=template&id=18dab82a"
import script from "./OfferInfo.vue?vue&type=script&lang=js"
export * from "./OfferInfo.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "18dab82a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18dab82a', script)) {
    api.reload('18dab82a', script)
  }
  
  module.hot.accept("./OfferInfo.vue?vue&type=template&id=18dab82a", () => {
    api.rerender('18dab82a', render)
  })

}

script.__file = "src/components/OfferInfo.vue"

export default script